<template>
<div>

  <div class="card-box-full" style="width: 500px">
    <div class="card-box-header">
      Welcome to the Command Center platform
    </div>

    <table width="100%">
      <tr>
        <td width="150" align="center" valign="middle">
          <img src="astronaut.png" width="125" height="125">
        </td>
      </tr>
  </td>
</tr>
</table>


  </div>



</div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
    }
  },
  methods: {
    //--------------------------------------------------------------------------
    openURL(url) {
      window.open(url, '_blank');
    }
  },
  mounted() {
  }
}
</script>
